var _rect, _rect2, _rect3, _circle, _path, _path2, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Smart watch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#F3EEFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 22,
    width: 44,
    height: 76,
    rx: 14,
    fill: "#002454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 34,
    width: 32,
    height: 52,
    rx: 6,
    fill: "#1A3D6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 54,
    r: 10,
    stroke: "#9e00ff",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 54 L80 46",
    stroke: "#9e00ff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54 L86 58",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 14,
    width: 24,
    height: 10,
    rx: 3,
    fill: "#002454"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 96,
    width: 24,
    height: 10,
    rx: 3,
    fill: "#002454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWatch);
export default __webpack_public_path__ + "static/media/product-watch.f37f94c7ec3466f7f322cc568f35ef99.svg";
export { ForwardRef as ReactComponent };